import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllPlans = (params) => {
    const ENDPOINT = ENDPOINTS.PLAN.GET_ALL;

    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append("search", params.search);
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.status) queryParams.append("status", params.status);
    if (params.startDate) queryParams.append("startDate", params.startDate);
    if (params.endDate) queryParams.append("endDate", params.endDate);

    const finalUrl = queryParams.toString() ?
        `${ENDPOINT}?${queryParams.toString()}` :
        `${ENDPOINT}`;

    return Api(finalUrl, null, requestType.GET);
};

const getSinglePlan = (id) => {
    const ENDPOINT = ENDPOINTS.PLAN.SINGLE.replace(":id", id);
    return Api(ENDPOINT, null, requestType.GET);
};

const getPlanDashboard = (query) => {

    const ENDPOINT = ENDPOINTS.PLAN.PLAN_DASHBOARD;
    const queryParams = new URLSearchParams();
    if (query.startDate) queryParams.append("startDate", query.startDate);
    if (query.endDate) queryParams.append("endDate", query.endDate);

    const finalUrl = queryParams.toString() ?
        `${ENDPOINT}?${queryParams.toString()}` :
        `${ENDPOINT}`;

    return Api(finalUrl, null, requestType.GET);
};

const deletePlan = (id) => {
    const ENDPOINT = ENDPOINTS.PLAN.DELETE.replace(":id", id);
    return Api(ENDPOINT, null, requestType.DELETE);
};

const getPlanById = (id) => {
    const ENDPOINT = ENDPOINTS.PLAN.SINGLE.replace(":id", id);
    return Api(ENDPOINT, null, requestType.GET);
};

const getPlanCreditSuggestion = (params) => {
    const url = ENDPOINTS.PLAN.GET_CREDIT_SUGGESTION;
    const queryParams = new URLSearchParams();
    queryParams.append("planAmount", params.amount);
    const finalUrl = queryParams.toString() ? `${url}?${queryParams}` : url;
  
    return Api(finalUrl, null, requestType.GET);
  };
  

export {
    getAllPlans,
    getSinglePlan,
    getPlanDashboard,
    deletePlan,
    getPlanById,
    getPlanCreditSuggestion,
};
